import svgUrl from "ni:svgr;cZ4y7uDkZxZoU8Dnxwci7V7uFUk3klssNQyZokzIo_g";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiStandardizeSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M15 2H6v9h9V2ZM6 1a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2h3a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6Zm5 11H6a1 1 0 0 1-1-1V6H3v8h8v-2ZM8.5 4a.5.5 0 0 0 0 1H10v3.5a.5.5 0 0 0 1 0V5h1.5a.5.5 0 0 0 0-1h-4Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiStandardizeSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiStandardizeSIcon)";
}